function PriceFormat({ amount }: { amount: number }) {
    const formatted = new Intl.NumberFormat('fr-MU', {
        style: 'currency',
        currency: 'MUR',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
    }).format(amount);

    return <span>{formatted}</span>;
}

export default PriceFormat;
